export default __webpack_public_path__ + "static/media/logo2.addd7447.png";